// Module
var code = `<date output-format="local-date"
      init-with-null="true"
      ng-required="\$ctrl.ngRequired"
      max="\$ctrl.max"
      ng-model="\$ctrl.valueDate"
      ng-change="\$ctrl.syncDateModel()"
></date>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/common/value-date.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;